import {Link} from "react-router-dom";

const serviceItems = [
    "Ремонт и техническое обслуживание грузовых автомобилей и прицепной техники;",
    "Выполнение работ по установке, регулировке и замене запасных частей, агрегатов и оборудования;",
    "Устранение выявленных в ходе диагностики дефектов и неисправностей;",
    "Проведение комплексной компьютерной диагностики, калибровки сенсоров и адаптации электронных блоков управления;",
    "Организация планового техобслуживания и составление индивидуальных сервисных графиков для автопарков.",
];

function Home() {
    return (
        <main className="page-main">
            <section className="hero">
                <div className="hero-inner">
                    <div className="content-box">
                        <h1>
                            Трак-Центр 24 — Сервис по ремонту и обслуживанию грузовых автомобилей
                        </h1>

                        <p className="lead">
                            Ремонт и обслуживание коммерческого грузового транспорта и спецтехники.
                            Быстро, прозрачно и с гарантией.
                        </p>

                        <p className="sub">
                            Специализация: FORD, Mercedes‑Benz, MAN, DAF, VOLVO, SCANIA и другие.
                        </p>

                        <div className="company-desc">
                            <p>
                                Трак-Центр 24 — это профессиональный сервис по комплексному ремонту и
                                техническому обслуживанию коммерческого транспорта и спецтехники. Мы
                                выполняем как плановое ТО, так и сложные ремонтные работы — от диагностики
                                двигателя и ходовой до ремонта коробок передач и электрооборудования.
                                Работы выполняются качественно, в срок и с официальной гарантией.
                            </p>

                            <p>
                                Наши специалисты имеют многолетний опыт работы с грузовыми марками: FORD,
                                Mercedes-Benz, MAN, DAF, VOLVO, SCANIA и другими. Используем современное
                                диагностическое оборудование и оригинальные либо проверенные аналоги
                                запчастей, что позволяет сократить время простоя техники и снизить
                                суммарную стоимость владения автомобилем.
                            </p>

                            <p>
                                <strong>Мы предлагаем:</strong>
                            </p>

                            <ul>
                                {serviceItems.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>

                            <p>
                                <strong>Почему выбирают нас:</strong> прозрачные сметы до начала работ,
                                оперативная связь и информирование по каждому этапу ремонта, удобные
                                условия для корпоративных клиентов и гибкие схемы оплаты. Мы ценим
                                безопасность и надежность — поэтому даём гарантию на все выполненные
                                работы и устанавливаем только проверенные комплектующие.
                            </p>

                            <p>
                                Наша цель — максимально быстро вернуть вашу технику в работу с минимальными
                                затратами и риском повторных поломок. Для постоянных клиентов доступны
                                приоритетное обслуживание и программы техподдержки, которые помогают
                                планировать бюджет и сокращать простои.
                            </p>

                            <p>
                                Свяжитесь с нами — оставьте заявку или позвоните, и мы подберём оптимальное
                                решение под ваш случай, подскажем сроки и предварительную стоимость работ.
                            </p>

                            <div className="company-careers-cta">
                                <div>
                                    <strong>Хотите работать у нас?</strong>
                                    <p>Будем рады видеть вас в нашей команде. Заполните короткую заявку, и мы свяжемся для обсуждения.</p>
                                </div>
                                <Link to="/staff/apply">Заполнить заявку на работу</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </main>
    );
}

export default Home;
